import React, { useEffect, useState } from "react";
import "./Landing.css";
import Header from "../Header/Header";
import BNB_logo from "../Assets/bnb.png";
import inETH from "../Assets/inETH.png";
import usdt from "../Assets/USDT.png";
import usdc from "../Assets/USDC.png";
import in_logo from "../Assets/in_logo.png";
import l_text from "../Assets/landing_text.png";
import { IoCopy } from "react-icons/io5";
import { useAccount, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";
import Countdown from "react-countdown";
import {
  preSale_Contract_ABI,
  preSale_Contract_Address,
  USDC_Contract_Abi,
  USDC_Contract_Address,
  USDT_Contract_Abi,
  USDT_Contract_Address,
} from "../../utilies/constant";
import Web3 from "web3";
import toast from "react-hot-toast";
import { CopyToClipboard } from "react-copy-to-clipboard";
const Completionist = () => {
  // window.location.reload();
  return <></>;
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  // console.log("renderer",items);
  if (completed) {
    return <Completionist />;
  } else {
    return (
      <div className="row timer_here">
        <div className="col-3">
          <div>
            <h1 className="numbers">{days}</h1>
            <p className="days nor_font mb-0">DAYS</p>
          </div>
        </div>
        <div className="col-3">
          <div>
            <h1 className="numbers">{hours}</h1>
            <p className="days nor_font mb-0">HOURS</p>
          </div>
        </div>
        <div className="col-3">
          <div>
            <h1 className="numbers">{minutes}</h1>
            <p className="days nor_font mb-0">Minutes</p>
          </div>
        </div>
        <div className="col-3">
          <div>
            <h1 className="numbers">{seconds}</h1>
            <p className="days nor_font mb-0">Seconds</p>
          </div>
        </div>
      </div>
    );
  }
};

export default function Landing() {
  const webSupply = new Web3("wss://bsc-rpc.publicnode.com");
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  const [plan, setplan] = useState(0);
  const [getBalance, setgetBalance] = useState(0);
  const [getBNB_value, setgetBNB_value] = useState("");
  const [showToken, setshowToken] = useState(0);
  const [spinner, setspinner] = useState(false);
  const [spinner2, setspinner2] = useState(false);
  const [refAddress, setRefAddress] = useState("");
  const [claimable, setclaimable] = useState(0);
  const [usdtraised, setusdtraised] = useState(0);
  const [totalreferearned, settotalreferearned] = useState(0);
  const [isclaim, setisclaimopen] = useState("");




  const [copied, setCopied] = useState(false);
  let history = window.location;

  const handleChange_value = (e) => {
    setgetBNB_value(e.target.value);
  };

  const contractData = async () => {
    try {
      let TokenContractOf = new webSupply.eth.Contract(
        USDC_Contract_Abi,
        USDC_Contract_Address
      );

      let TokenContractOfUSDT = new webSupply.eth.Contract(
        USDT_Contract_Abi,
        USDT_Contract_Address
      );
      let ContractOf = new webSupply.eth.Contract(
        preSale_Contract_ABI,
        preSale_Contract_Address
      );
      let totalUSDTRa = await ContractOf.methods
      .totalUSDTRaised()
      .call();
 
      totalUSDTRa = webSupply.utils.fromWei(totalUSDTRa.toString())
      setusdtraised(totalUSDTRa)

      // let totalReferEarn = await ContractOf.methods
      // .totalReferEarned()
      // .call();

      // totalReferEarn = webSupply.utils.fromWei(totalReferEarn.toString());
      // settotalreferearned(totalReferEarn)

      let isclaimopen = await ContractOf.methods
      .IsClaim()
      .call();
      setisclaimopen(isclaimopen)

    } catch (error) {
      console.log(error);
    }
  };

  const balanceOf = async () => {
    try {
      let TokenContractOf = new webSupply.eth.Contract(
        USDC_Contract_Abi,
        USDC_Contract_Address
      );

      let TokenContractOfUSDT = new webSupply.eth.Contract(
        USDT_Contract_Abi,
        USDT_Contract_Address
      );
      let ContractOf = new webSupply.eth.Contract(
        preSale_Contract_ABI,
        preSale_Contract_Address
      );
      let totalUSDTRa = await ContractOf.methods
      .totalUSDTRaised()
      .call();
 
      totalUSDTRa = webSupply.utils.fromWei(totalUSDTRa.toString())
      setusdtraised(totalUSDTRa)

      // let totalReferEarn = await ContractOf.methods
      // .totalReferEarned()
      // .call();

      // totalReferEarn = webSupply.utils.fromWei(totalReferEarn.toString());
      // settotalreferearned(totalReferEarn)

      let isclaimopen = await ContractOf.methods
      .IsClaim()
      .call();
      setisclaimopen(isclaimopen)
      let value_BNB = webSupply.utils.toWei(
        getBNB_value == "" ? "0" : getBNB_value.toString()
      );
      if (plan == 0) {
        let get_BNBTO_Token = await ContractOf.methods
          .BNBToToken(value_BNB)
          .call();
        get_BNBTO_Token = webSupply.utils.fromWei(get_BNBTO_Token.toString());
        setshowToken(get_BNBTO_Token);
      } else if (plan == 1) {
        let get_USDCTOToken = await ContractOf.methods
          .getValuePerUSDC(value_BNB)
          .call();
        get_USDCTOToken = webSupply.utils.fromWei(get_USDCTOToken.toString());
        setshowToken(get_USDCTOToken);
      } else {
        let get_USDCTOToken = await ContractOf.methods
          .getValuePerUSDC(value_BNB)
          .call();
        get_USDCTOToken = webSupply.utils.fromWei(get_USDCTOToken.toString());
        setshowToken(get_USDCTOToken);
      }
      if (address) {

        let claimabletoken = await ContractOf.methods
        .Claimable(address)
        .call();
        claimabletoken = webSupply.utils.fromWei(claimabletoken.toString());
        setclaimable(claimabletoken);

     
        if (plan == 0) {
          let bnb_Balance = await webSupply.eth.getBalance(address);
          console.log("bnb_Balance", bnb_Balance);

          bnb_Balance = webSupply.utils.fromWei(bnb_Balance.toString());
          setgetBalance(bnb_Balance.toString());
        } else if (plan == 1) {
          let USDC_Balance = await TokenContractOf.methods
            .balanceOf(address)
            .call();
          USDC_Balance = webSupply.utils.fromWei(USDC_Balance.toString());
          setgetBalance(USDC_Balance.toString());
         
        } else {
          let USDT_Balance = await TokenContractOfUSDT.methods
            .balanceOf(address)
            .call();
          USDT_Balance = webSupply.utils.fromWei(USDT_Balance.toString());
          setgetBalance(USDT_Balance.toString());
          
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const staking_Amount = async () => {
    try {
      if (getBNB_value == "") {
        toast.error("Please Enter Amount First!");
        setspinner(false);
      } else {
        if (getBNB_value > getBalance) {
          toast.error("Insufficient Balance");
          setspinner(false);
        } else {
          if (!address) {
            toast.error("Please Connect Metamaske First!");
          } else {
            const queryString = window.location.search;
            const parameters = new URLSearchParams(queryString);
            let RefferalAddress = parameters.get("ref");
            if (RefferalAddress == null) {
              RefferalAddress = "0x0000000000000000000000000000000000000000";
            }
            if (plan == 0) {
              setspinner(true);
              let stakingValue;
              stakingValue = webSupply.utils.toWei(getBNB_value.toString());
              const { request } = await prepareWriteContract({
                address: preSale_Contract_Address,
                abi: preSale_Contract_ABI,
                functionName: "BuyWithBNB",
                args: [],
                value: stakingValue.toString(),
                account: address,
              });
              const { hash } = await writeContract(request);
              const data = await waitForTransaction({
                hash,
              });
              setspinner(false);
              toast.success("Purchase Successful");
            } else if (plan == 1) {
              console.log("RefferalAddress", RefferalAddress);
              setspinner(true);
              let preSaleValue;
              preSaleValue = webSupply.utils.toWei(getBNB_value.toString());
              const { request } = await prepareWriteContract({
                address: USDC_Contract_Address,
                abi: USDC_Contract_Abi,
                functionName: "approve",
                args: [preSale_Contract_Address, preSaleValue.toString()],
                account: address,
              });
              const { hash } = await writeContract(request);
              const data = await waitForTransaction({
                hash,
              });

              setTimeout(async () => {
                toast.success("Approve Successful");
                const { request } = await prepareWriteContract({
                  address: preSale_Contract_Address,
                  abi: preSale_Contract_ABI,
                  functionName: "BuyWithUSDC",
                  args: [ preSaleValue.toString()],
                  account: address,
                });
                const { hash } = await writeContract(request);
                const data = await waitForTransaction({
                  hash,
                });
                setspinner(false);
                toast.success("Purchase Successful");
              }, 3000);
            } else {
              console.log("RefferalAddress", RefferalAddress);
              setspinner(true);
              let preSaleValue;
              preSaleValue = webSupply.utils.toWei(getBNB_value.toString());
              const { request } = await prepareWriteContract({
                address: USDT_Contract_Address,
                abi: USDC_Contract_Abi,
                functionName: "approve",
                args: [preSale_Contract_Address, preSaleValue.toString()],
                account: address,
              });
              const { hash } = await writeContract(request);
              const data = await waitForTransaction({
                hash,
              });

              setTimeout(async () => {
                toast.success("Approve Successful");
                const { request } = await prepareWriteContract({
                  address: preSale_Contract_Address,
                  abi: preSale_Contract_ABI,
                  functionName: "BuyWithUSDT",
                  args: [preSaleValue.toString()],
                  account: address,
                });
                const { hash } = await writeContract(request);
                const data = await waitForTransaction({
                  hash,
                });
                setspinner(false);
                toast.success("Purchase Successful");
              }, 3000);
            }
          }
        }
      }
    } catch (e) {
      console.log("Error", e);
      setspinner(false);
    }
  };


  const claim = async () => {
    try {

        if (isclaim == false) {
          toast.error("Presale is running!");
          setspinner2(false);
        } else {
              setspinner2(true);
              const { request } = await prepareWriteContract({
                address: preSale_Contract_Address,
                abi: preSale_Contract_ABI,
                functionName: "claim",
                args: [],
                account: address,
              });
              const { hash } = await writeContract(request);
              const data = await waitForTransaction({
                hash,
              });
              setspinner2(false);
              toast.success("Claim Successful");
            } 
            
          }
        
      
     catch (e) {
      console.log("Error", e);
      setspinner(false);
    }
  };
  useEffect(() => {
    balanceOf();
  }, [getBNB_value, address, plan]);

  useEffect(() => { 
    setInterval(() => { 
      contractData(); 
    }, 1000); 
  }, [address]); 


  useEffect(() => {
    if (address) {
      setRefAddress(`${history.origin}/buy_token?ref=${address}`);
    } else {
      setRefAddress("Connect wallet");
    }
    setInterval(() => {
      setCopied(false);
    }, 3000);
  }, [address, copied]);

  return (
    <div className="landing_bg overflow-hidden">
      {/* <Header /> */}
      <div className="footer_overlay"></div>

      <div className="container">
        <div className="row justify-content-between align-items-center mt-4">
          <div className="col-md-5 z-2 position-relative " data-aos="fade-right">
          <h1 className="section_head  text-white reff gor_font text-center">Welcome to The <span style={{color:"#E647BF"}}>

          Rabbits  </span>  Presale</h1>
            {/* <img src={l_text} className="w-100" alt="" /> */}
          </div>
          <div className="col-md-7  z-2 position-relative mt-3 mt-md-0 col-lg-5" data-aos="fade-left" >
            <div className="preslae_box">

            <p
                className="one_quokka sans_font text-center fw-bold"
                style={{ color: "##E647BF", fontSize: "40px"}}
              >
                Round 2
              </p>
              <p
                className="nor_font mb-0 my-2 text-center fw-bold"
                style={{ color: "#0B112F" }}
              >
                $RBT.network Coin Presale is Live!
              </p>

              <Countdown
                date={parseInt("1736614603") * 1000}
                renderer={renderer}
              />
              <p
                className="nor_font mb-0 my-2 text-center fw-bold"
                style={{ color: "#0B112F" }}
              >
                USDT Raised: ${parseFloat(Number(usdtraised)+Number(135000)).toFixed(4)} / $1,000,000
                {/* USDT Raised: $135,000 / $1,000,000 */}
              </p>

              <div className="progress_bar mt-2">
                <div className="iner_pro"style={{
                          width: `${(((Number(usdtraised)+Number(135000))) / Number(1000000)) * 100
                            }%`,
                        }}>

                </div>
              </div>
              <p className="raised nor_font mt-2  ">
                Your purchased $RBT.network = {parseFloat(claimable).toFixed(4)}
              </p>

              <h6 className=" one_quokka sans_font">1 $RBT.network = $0.00001667</h6>

              <div className="row mt-3 justify-content-center">
                <div className="col-4 col-md-3 ps-md-0 me-0 me-md-1 ">
                  <button
                    className="eths_btn"
                    style={{ backgroundColor: plan == 0 ? "#E647BF" : "" }}
                    onClick={() => setplan(0)}
                  >
                    <img src={BNB_logo} alt="" />
                    <span style={{ color: plan == 0 ? "#fff" : "" }}>BNB</span>
                  </button>
                </div>
                <div className="col-4 col-md-3 ps-0">
                  <button
                    className="eths_btn"
                    style={{ backgroundColor: plan == 1 ? "#E647BF" : "" }}
                    onClick={() => setplan(1)}
                  >
                    <img src={usdt} alt="" />
                    <span style={{ color: plan == 1 ? "#fff" : "" }}>USDT</span>
                  </button>
                </div>
                <div className="col-4 col-md-3  ">
                  <button
                    className="eths_btn"
                    style={{ backgroundColor: plan == 2 ? "#E647BF" : "" }}
                    onClick={() => setplan(2)}
                  >
                    <img src={usdc} alt="" />
                    <span style={{ color: plan == 2 ? "#fff" : "" }}>USDC</span>
                  </button>
                </div>
              </div>
              <p className="raised nor_font mt-2 ">
                {" "}
                <span className="balnce">Your Balance</span> ={" "}
                {parseFloat(getBalance).toFixed(3)} {}{" "}
                {plan == 0 ? "BNB" : plan == 1 ? "USDT " : "USDC "}
              </p>
              <div className="row mt-4">
                <div className="col-6">
                  <div className="d-flex justify-content-between">
                  Amount in{" "}
                  {plan == 0 ? "BNB" : plan == 1 ? "USDT" : "USDC"}
                    <p
                      className="pay_with site_font mb-0"
                      onClick={() =>
                        setgetBNB_value(
                          getBalance !== "0"
                            ? Number(getBalance) - Number(0.0001)
                            : 0
                        )
                      }
                    >
                      Max
                    </p>
                  </div>
                  <div className="position-relative">
                    <input
                      type="number"
                      placeholder="0"
                      className="pay_with_input site_font"
                      value={getBNB_value}
                      onChange={handleChange_value}
                    />
                    <img
                      src={plan == 0 ? BNB_logo : plan == 1 ? usdt : usdc}
                      className="eth_img"
                      style={{ width: "28px " }}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex justify-content-between">
                    <p className="pay_with site_font mb-0">
                      Receive{" "}
                      <span style={{ color: "#FF2439", fontWeight: "800" }}>
                        {" "}
                        $RBT.network Coin
                      </span>{" "}
                    </p>
                  </div>
                  <div className="position-relative">
                    <input
                      type="number"
                      placeholder="0"
                      className="pay_with_input site_font"
                      value={showToken}
                    />
                    <img
                      src={in_logo}
                      style={{ width: "28px " }}
                      className="eth_img"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div>
                <button
                  className="connect_wallet w-100 text-white mt-3 nor_font"
                  onClick={staking_Amount}
                >
                  {spinner ? "Loading..." : "Buy Now"}
                </button>
                <button
                  className="connect_wallet w-100 mt-3 text-white nor_font"
                  onClick={() =>
                    address
                      ? chain?.id == chains[0]?.id
                        ? open()
                        : switchNetwork?.(chains[0]?.id)
                      : open()
                  }
                >
                  {address ? (
                    chain?.id == chains[0]?.id || chain?.id == chains[1]?.id ? (
                      address ? (
                        <>
                          {`${address?.substring(0, 6)}...${address?.substring(
                            address.length - 4
                          )}`}
                        </>
                      ) : (
                        <>Connect Wallet</>
                      )
                    ) : (
                      "Switch NetWork"
                    )
                  ) : (
                    <>Connect Wallet</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3" >
          <div className="col-md-12  z-2 position-relative">
            <div className="    preslae_box ref_bo" data-aos="fade-up"   data-aos-duration="1800">
              <h1 className="section_head reff gor_font text-center">
                You can claim your token , once claiming will be On
              </h1>
              <div className="row justify-content-center">
                <div className="col-6 col-md-4">
                  <div className="inner_ref_box">
                    <h5 className="nor_font mb-0 text-uppercase   fw-bold">
                      Total Raised $                  </h5>
                    {/* <h2 className="nor_font mb-0 fw-bold ">{parseFloat(usdtraised).toFixed(4)} $</h2> */}
                    <h2 className="nor_font mb-0 fw-bold ">{parseFloat(Number(usdtraised)+Number(135000)).toFixed(4)} $</h2>
                  </div>
                </div>  
              </div>
              <p
                className="nor_font mb-0 mt-3 text-center"
                style={{ color: " rgb(11, 17, 47)" }}
              >
                Claim Your {parseFloat(claimable).toFixed(4)} Token Now 
              </p>
              <div className="d-flex justify-content-center mt-3">
                <button className="connect_wallet nor_font  text-white   "    onClick={claim}
                >
                  {spinner2 ? "Loading..." : "Claim"}
                </button>
              </div>
       

              <p
                className=" nor_font  text-center mt-2"
                style={{ color: " rgb(11, 17, 47)" }}
              >
                Please note that you have to claim your tokens once claiming will be On.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
